import { useEffect, useState } from 'react'

export function useLocalStorage(key, initialValue) {
    const [value, setValue] = useState(() => {
        const jsonValue = localStorage.getItem(key)
        let bFail = true
        if (typeof jsonValue !== 'undefined' && jsonValue !== null) {
            bFail = false
        }
        if (bFail) {
            return initialValue
        } else {
            return JSON.parse(jsonValue)
        }
    })

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value))
    }, [key, value])

    return [value, setValue]
}

// usage
//useLocalStorage("shop-cart", [])
